import React from "react";
import Slider from "react-slick";
import { getProducts } from "./new-arrivals.service";
import { ProductCard } from "../common/product-card";
import { Link } from "react-router-dom";
export interface Product {
  id: string;
  title: string;
  oldPrice: string;
  newPrice: string;
  image: any;
  hoverImage: string;
  flags?: string[];
  outOfStock?: boolean;
  code: string;
  name: string;
  category: string;
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1500,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};
const NewArrivals: React.FC = () => {
  const [products, setProducts] = React.useState<Product[]>([]);
  React.useEffect(() => {
    getProducts().then((response) => {
      let products = response.data;
      if (products.length === 1) {
        products = [...products, ...products];
      }
      setProducts(products);
    });
  }, []);

  if (products.length === 0) {
    return null;
  }

  return (
    <section className="section ec-trend-product section-space-p">
      <div className="container">
        <div className="row">
          <div className="col-md-12 section-title-block">
            <div className="section-title">
              <h2 className="ec-title">New Arrivals</h2>
              <p className="sub-title">Check out our new arrivals products.</p>
            </div>
            <div className="section-btn">
              <span className="ec-section-btn">
                <Link className="btn-secondary" to="/products">
                  View All
                </Link>
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <Slider className="ec-trend-slider" {...settings}>
            {products.map((product) => (
              <div
                className="col-lg-3 col-md-6 col-sm-6 col-xs-6 ec-product-content"
                style={{
                  width: "100%",
                }}
              >
                <ProductCard isSample={false} key={product.id} {...product} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default NewArrivals;
